<template>
  <v-pagina-de-apresentacao>
    <template v-slot:main-content>
      <div class="text-center accent--text text-h4 mt-n4">
        Vamos trocar sua senha
      </div>
      <v-card class="elevation-7 pa-8 mt-2" rounded="lg" color="accent">
        <div flat color="accent">
          <v-toolbar-title class="text-h5"
            >Informe o seu email de login</v-toolbar-title
          >
        </div>
        <ValidationObserver v-slot="{ invalid }">
          <v-form @submit.prevent="onSubmit" ref="form" lazy-validation>
            <v-card-text>
              <ValidationProvider
                name="Name"
                rules="required|email"
                v-slot="{ errors, valid }">
                <v-text-field
                  type="text"
                  label="Digite aqui o seu email"
                  name="email"
                  prepend-icon="person"
                  required
                  v-model="email"
                  :error-messages="errors"
                  :success="valid" />
              </ValidationProvider>
              Concluiu?
              <router-link :to="{ name: 'login' }"
                >Entre no sistema.</router-link
              >
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                type="submit"
                color="primary"
                block
                large
                :loading="loading"
                :disabled="invalid"
                >Enviar</v-btn
              >
            </v-card-actions>
          </v-form>
        </ValidationObserver>
      </v-card>
    </template>
  </v-pagina-de-apresentacao>
</template>

<script>
import VPaginaDeApresentacao from "@/layouts/PaginaDeApresentacao"
import { mapActions } from "vuex"

import { ValidationObserver, ValidationProvider } from "vee-validate"
import messageMixin from "@/mixins/translateMessageMixin"

const PEDIDO_SUCESSO = "Pedido enviado com sucesso. Verifique seu email."

export default {
  components: { ValidationObserver, ValidationProvider, VPaginaDeApresentacao },
  mixins: [messageMixin],
  data: () => ({
    loading: false,
    email: "",
  }),
  methods: {
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.loading = true
        this.$store
          .dispatch("auth/recover", this.email)
          .then((res) => {
            if (res.status == 200) {
              this.showSucesso(PEDIDO_SUCESSO)
            } else {
              this.showErro(this.getMessage(res.data.error.message))
            }
          })
          .catch(({ response }) => {
            this.showErro(this.getMessage(response.data.error.message))
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    ...mapActions("message", ["showSucesso", "showErro"]),
  },
}
</script>
